import { checkStatus } from 'utils/request';

export const ERROR_NOT_CWCALC_CODE = 'NOT_CWCALC_CODE';

const apiKey = '9aebdb58-fad2-4569-90bd-0d4a8fd9903c';
const dexfUrl = 'https://api.dexf.ikea.com/vpc/v1/configurations'

export function createVpcConfigurationSourceError() {
  const error = new Error('This is not a CWCALC code');
  error.name = ERROR_NOT_CWCALC_CODE;

  return error;
}

export function getPlanFromVPC(locale, code) {
  return fetch(`${dexfUrl}/retailunit/${locale.country.toUpperCase()}/locale/${locale.language.toLowerCase()}-${locale.country.toUpperCase()}/${code}`, {
    headers: {
      Accept: 'application/json',
      'DEXF-API-KEY': apiKey
    },
  })
  .then(checkStatus)
  .then((response) => response.json())
  .then((response) => {
    if (response.application.toUpperCase() !== 'CWCALC') {
      throw createVpcConfigurationSourceError();
    }
    return response;
  });
}

export function savePlanToVPC(locale, body) {
  return fetch(`${dexfUrl}/retailunit/${locale.country.toUpperCase()}/locale/${locale.language.toLowerCase()}-${locale.country.toUpperCase()}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'DEXF-API-KEY': apiKey
    },
    body,
  })
  .then(checkStatus)
  .then((response) => response.json());
}
